export const translations = {
  da: {
    nav: {
      home: "Forside",
      about: "Om René",
      services: "Ydelser",
      erp: "ERP Lead",
      data: "Data Migration",
      agile: "Agile Scrum Coach",
      experience: "Erfaring",
      contact: "Kontakt"
    },
    header: {
      specialist: "Senior Freelance ERP & Data Migration Specialist",
      linkedinContact: "Kontakt på LinkedIn",
      linkedinFollow: "Følg René på LinkedIn",
      location: "Svendborg, Danmark",
      closeMenu: "Luk menu",
      toggleMenu: "Toggle menu"
    },
    footer: {
      description: "Insightly ApS leverer uvildig og professionel IT-rådgivning med speciale i ERP, datamigrering og agil transformation.",
      contact: "Kontakt",
      cvr: "CVR:",
      rights: "Alle rettigheder forbeholdes.",
      phone: "Telefon",
      email: "E-mail",
      address: "Adresse",
      addressValue: "Dronningemaen 68, 5700 Svendborg",
      linkedin: "LinkedIn",
      linkedinConnect: "Forbind på LinkedIn",
      formDesc: "Udfyld formularen nedenfor, så vender René tilbage til dig hurtigst muligt.",
      formSuccessNew: "Send en ny besked",
      contactTitle: "Kontakt",
      contactQuote: "Har dit ERP-program brug for struktur, momentum og en sikker levering? Eller står I overfor en kompleks datamigrering, hvor I mangler en erfaren styrmand?",
      contactText: "Lad os tage en uforpligtende dialog om, hvordan jeg kan hjælpe jeres organisation sikkert i mål. René dækker de mest kritiske roller i komplekse ERP- og transformationsprogrammer og arbejder som bindeled mellem forretning, IT og implementeringspartnere.",
      socialMedia: "Sociale medier",
      advisory: "Senior Freelance ERP & Project Advisory"
    },
    contactForm: {
      title: "Send en besked",
      name: "Navn",
      email: "E-mail",
      phone: "Telefon",
      message: "Besked",
      send: "Send besked",
      sending: "Sender...",
      success: "Tak for din besked. Jeg vender tilbage hurtigst muligt.",
      error: "Der opstod en fejl. Prøv venligst igen."
    },
    home: {
      heroTitle: "Uvildig IT-rådgivning & Projektledelse",
      heroSubtitle: "Med over 20 års erfaring hjælper jeg virksomheder sikkert i mål med komplekse ERP-implementeringer, datamigreringer og agile transformationer.",
      heroCta1: "Se mine ydelser",
      heroCta2: "Kontakt mig",
      heroCta3: "Kontakt på LinkedIn",
      servicesTitle: "Kernekompetencer",
      servicesSubtitle: "Jeg tilbyder specialiseret rådgivning inden for tre hovedområder, hvor jeg kombinerer dyb teknisk forståelse med forretningsmæssig indsigt.",
      erpTitle: "ERP Lead",
      erpDesc: "Styring af komplekse ERP-projekter fra analyse til succesfuld go-live.",
      dataTitle: "Data Migration",
      dataDesc: "Sikker og struktureret flytning af forretningskritisk data.",
      agileTitle: "Agile Scrum Coach",
      agileDesc: "Implementering af agile metoder der skaber reel værdi.",
      readMore: "Læs mere",
      testimonialsTitle: "Det siger kunderne",
      testimonialsSubtitle: "Et udpluk af udtalelser fra tidligere samarbejdspartnere og kunder.",
      valuePropositionTag: "Værditilbud",
      valuePropositionQuote: "ERP-programmer leveret med struktur og fremdrift",
      valuePropositionText: "Senior ERP-ledelse med fokus på governance, datamigrering og samarbejde mellem forretning, IT og implementeringspartnere – fra planlægning til sikker go-live.",
      experienceDomainTag: "Erfaring på tværs af domæner",
      experienceDomainTitle: "Kombinerer governance med pragmatisk, hands-on execution",
      experienceDomainText: "René arbejder i spændingsfeltet mellem forretningen, IT-afdelingen og de eksterne implementeringspartnere. Han designer skalérbare migreringsframeworks, etablerer agilitet og sikrer, at jeres data er pålidelige, og jeres teams er trygge og afklarede før go-live.",
      deliveryTitle: "Sikker levering",
      deliveryText: "Fokus på go-live readiness og operational stability, der virker i virkeligheden.",
      governanceTitle: "Stærk governance",
      governanceText: "Kombinerer strategisk governance med pragmatisk, hands-on eksekvering.",
      servicesTag: "Vores ydelser",
      servicesTitle2: "Professionelle ydelser med menneskelig indsigt",
      servicesSubtitle2: "René dækker de mest kritiske roller i komplekse ERP- og transformationsprogrammer.",
      erpServiceDesc: "Fokus på struktur, governance, beslutningskraft, fremdrift og koordinering mellem forretning, IT og implementeringspartnere.",
      dataServiceDesc: "Fokus på migreringsframeworks, master data, datakvalitet, compliance, go-live readiness og stabil drift efter go-live.",
      pmTitle: "Project Manager",
      pmServiceDesc: "Styring af scope, tid og ressourcer i komplekse forretningsmiljøer. Brobygning mellem IT og forretning med fokus på fremdrift.",
      agileServiceDesc: "Fokus på transparens, cadence, psykologisk tryghed, teamflow og praktisk agil eksekvering i komplekse programmer.",
      seeExperience: "Se erfaring",
      strategicTag: "Strategisk positionering",
      strategicTitle: "Hjælper organisationer med at genvinde kontrol over komplekse ERP-initiativer",
      strategicText: "Gennem gennemsigtighed, cadence og psykologisk tryghed flytter vi teams fra fragmenteret indsats til forudsigelig levering.",
      personTag: "Mennesket bag",
      personTitle: "Mød René Vilsgaard",
      personCta: "Læs mere om René",
      personSubtitle: "Hvor komplekse systemer møder menneskelig varme",
      personText1: "I Insightly ApS er René selve produktet. Han er uddannet <strong class=\"text-navy-900\">erhvervspsykoterapeut</strong> og medlem af <a href=\"https://psykoterapeutforeningen.dk\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-petrol hover:underline inline-flex items-center gap-1 font-semibold\">Dansk Psykoterapeutforening <i class=\"fa-solid fa-arrow-up-right-from-square text-[10px]\"></i></a>. Han tror på, at de bedste ERP-løsninger ikke kun skabes af kode og databaser, men af de mennesker, der skal bruge dem. Med en personlig, nærværende og tillidsvækkende tilgang træder han direkte ind i jeres organisation.",
      personText2: "Han skaber et miljø præget af psykologisk tryghed, hvor teams tør tage ejerskab, og hvor gennemsigtighed og en fast kadence driver projektet fremad. Det handler om at gå fra fragmenteret indsats til forudsigelig levering – med et smil på læben og respekt for det enkelte menneske.",
      customersTag: "Kundernes stemme",
      customersTitle: "Hvad siger kunderne?",
      customersSubtitle: "Udtalelser fra virksomheder og samarbejdspartnere, der har haft René med på sidelinjen i komplekse forløb.",
      experienceTag: "Dokumenteret erfaring",
      experienceTitle: "Udvalgte cases & resultater",
      experienceCta: "Se al erfaring",
      skillsInPlay: "Kompetencer i spil",
      trackRecordTag: "Track record · Cases",
      projectDescTitle: "Projektbeskrivelse & Resultater",
      ctaTitle: "Skal vi skabe det næste succesfulde resultat sammen?",
      ctaText: "René står klar til at træde ind som jeres uafhængige rådgiver og lead. Lad os tage en uforpligtende snak om, hvordan vi sikrer jeres projekt."
    },
    about: {
      title: "Om René",
      subtitle: "Erfaren IT-konsulent med fokus på at skabe bro mellem forretning og teknologi.",
      content1: "Jeg har arbejdet med IT-projekter i over to årtier og har en dyb passion for at få komplekse systemer og mennesker til at spille sammen. Min tilgang er pragmatisk, ærlig og altid med fokus på at levere reel værdi for forretningen.",
      content2: "Gennem min karriere har jeg haft roller som projektleder, løsningsarkitekt og agil coach. Det har givet mig en bred forståelse for de udfordringer, der opstår i store IT-transformationer, og hvordan man bedst løser dem.",
      contactCta: "Lad os tage en uforpligtende snak",
      personTag: "Mennesket bag produktet",
      compassTitle: "Renés faglige og personlige kompas",
      safetyTitle: "Psykologisk tryghed",
      safetyText: "Når teams føler sig trygge, tør de sige sandheden om risici og fejl. Det er fundamentet for enhver succesfuld go-live.",
      cadenceTitle: "Fast kadence & transparens",
      cadenceText: "Klarhed over opgaver, ejerskab og fremdrift fjerner stress og skaber forudsigelig levering (predictable delivery).",
      bridgeTitle: "Brobygning",
      bridgeText: "René taler både forretningens, IT-afdelingens og implementeringspartnerens sprog, hvilket sikrer fuld alignment.",
      pragmaticTitle: "Pragmatisk eksekvering",
      pragmaticText: "Governance er vigtigt, men det skal altid tilpasses det virkelige forretningsmiljø, så det understøtter driften.",
      profileTag: "Senior Freelance ERP Specialist, Coach & Erhvervspsykoterapeut",
      profileQuote: "\"Jeg tror på, at komplekse ERP-systemer kun lykkes, hvis de mennesker, der skal bruge dem, er trygge, motiverede og alignede.\"",
      therapist: "Erhvervspsykoterapeut",
      member: "Medlem af Dansk Psykoterapeutforening",
      linkedinTitle: "Kontakt René på LinkedIn",
      linkedinText: "René deler jævnligt erfaringer, artikler og agile tips på sin LinkedIn-profil. Ræk ud for en uforpligtende snak eller følg hans faglige opdateringer.",
      linkedinConnect: "Forbind på LinkedIn",
      visualTag: "Visuel dokumentation",
      visualClick: "Klik på et billede for at se det i stor visning."
    },
    experience: {
      title: "Erfaring",
      subtitle: "Et overblik over udvalgte projekter og roller gennem min karriere.",
      period: "Periode",
      skills: "Kompetencer"
    },
    services: {
      erpSubtitle: "Få styring på dit ERP-projekt med en erfaren lead, der forstår både forretning og teknik.",
      dataSubtitle: "Minimer risikoen ved systemskift med en struktureret tilgang til datamigrering.",
      agileSubtitle: "Skab bedre resultater og højere trivsel med velfungerende agile teams."
    },
    contact: {
      title: "Kontakt",
      subtitle: "Lad os tage en dialog om, hvordan jeg kan hjælpe med dit næste IT-projekt.",
      infoTitle: "Kontaktoplysninger",
      infoDesc: "Du er altid velkommen til at ringe eller skrive for en uforpligtende snak om dine udfordringer og behov.",
      contactTag: "Kontakt · Insightly ApS",
      companyInfo: "Virksomhedsoplysninger"
    },
    errors: {
      forbidden: "Adgang nægtet",
      forbiddenDesc: "Du har ikke rettigheder til at se denne side.",
      notFound: "Siden blev ikke fundet",
      notFoundDesc: "Siden du leder efter findes ikke eller er blevet flyttet.",
      backHome: "Tilbage til forsiden"
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About René",
      services: "Services",
      erp: "ERP Lead",
      data: "Data Migration",
      agile: "Agile Scrum Coach",
      experience: "Experience",
      contact: "Contact"
    },
    header: {
      specialist: "Senior Freelance ERP & Data Migration Specialist",
      linkedinContact: "Contact on LinkedIn",
      linkedinFollow: "Follow René on LinkedIn",
      location: "Svendborg, Denmark",
      closeMenu: "Close menu",
      toggleMenu: "Toggle menu"
    },
    footer: {
      description: "Insightly ApS provides independent and professional IT consulting specializing in ERP, data migration, and agile transformation.",
      contact: "Contact",
      cvr: "VAT:",
      rights: "All rights reserved.",
      phone: "Phone",
      email: "Email",
      address: "Address",
      addressValue: "Dronningemaen 68, 5700 Svendborg, Denmark",
      linkedin: "LinkedIn",
      linkedinConnect: "Connect on LinkedIn",
      formDesc: "Fill out the form below, and René will get back to you as soon as possible.",
      formSuccessNew: "Send a new message",
      contactTitle: "Contact",
      contactQuote: "Does your ERP program need structure, momentum, and secure delivery? Or are you facing a complex data migration where you need an experienced helmsman?",
      contactText: "Let's have a non-binding dialogue about how I can help your organization safely reach its goals. René covers the most critical roles in complex ERP and transformation programs and works as a link between business, IT, and implementation partners.",
      socialMedia: "Social media",
      advisory: "Senior Freelance ERP & Project Advisory"
    },
    contactForm: {
      title: "Send a message",
      name: "Name",
      email: "Email",
      phone: "Phone",
      message: "Message",
      send: "Send message",
      sending: "Sending...",
      success: "Thank you for your message. I will get back to you as soon as possible.",
      error: "An error occurred. Please try again."
    },
    home: {
      heroTitle: "Independent IT Consulting & Project Management",
      heroSubtitle: "With over 20 years of experience, I help companies successfully navigate complex ERP implementations, data migrations, and agile transformations.",
      heroCta1: "View my services",
      heroCta2: "Contact me",
      heroCta3: "Contact on LinkedIn",
      servicesTitle: "Core Competencies",
      servicesSubtitle: "I offer specialized consulting in three main areas, combining deep technical understanding with business insight.",
      erpTitle: "ERP Lead",
      erpDesc: "Management of complex ERP projects from analysis to successful go-live.",
      dataTitle: "Data Migration",
      dataDesc: "Secure and structured transfer of business-critical data.",
      agileTitle: "Agile Scrum Coach",
      agileDesc: "Implementation of agile methods that create real value.",
      readMore: "Read more",
      testimonialsTitle: "Client Testimonials",
      testimonialsSubtitle: "A selection of testimonials from previous partners and clients.",
      valuePropositionTag: "Value Proposition",
      valuePropositionQuote: "ERP programs delivered with structure and momentum",
      valuePropositionText: "Senior ERP leadership with a focus on governance, data migration, and collaboration between business, IT, and implementation partners – from planning to secure go-live.",
      experienceDomainTag: "Experience across domains",
      experienceDomainTitle: "Combining governance with pragmatic, hands-on execution",
      experienceDomainText: "René works in the crossfire between the business, the IT department, and external implementation partners. He designs scalable migration frameworks, establishes agility, and ensures that your data is reliable and your teams are confident and aligned before go-live.",
      deliveryTitle: "Secure delivery",
      deliveryText: "Focus on go-live readiness and operational stability that works in reality.",
      governanceTitle: "Strong governance",
      governanceText: "Combines strategic governance with pragmatic, hands-on execution.",
      servicesTag: "Our services",
      servicesTitle2: "Professional services with human insight",
      servicesSubtitle2: "René covers the most critical roles in complex ERP and transformation programs.",
      erpServiceDesc: "Focus on structure, governance, decision-making, progress, and coordination between business, IT, and implementation partners.",
      dataServiceDesc: "Focus on migration frameworks, master data, data quality, compliance, go-live readiness, and stable operations after go-live.",
      pmTitle: "Project Manager",
      pmServiceDesc: "Management of scope, time, and resources in complex business environments. Bridging IT and business with a focus on progress.",
      agileServiceDesc: "Focus on transparency, cadence, psychological safety, team flow, and practical agile execution in complex programs.",
      seeExperience: "See experience",
      strategicTag: "Strategic positioning",
      strategicTitle: "Helping organizations regain control of complex ERP initiatives",
      strategicText: "Through transparency, cadence, and psychological safety, we move teams from fragmented efforts to predictable delivery.",
      personTag: "The person behind",
      personTitle: "Meet René Vilsgaard",
      personCta: "Read more about René",
      personSubtitle: "Where complex systems meet human warmth",
      personText1: "In Insightly ApS, René is the product itself. He is a trained <strong class=\"text-navy-900\">business psychotherapist</strong> and a member of the <a href=\"https://psykoterapeutforeningen.dk\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-petrol hover:underline inline-flex items-center gap-1 font-semibold\">Danish Psychotherapist Association <i class=\"fa-solid fa-arrow-up-right-from-square text-[10px]\"></i></a>. He believes that the best ERP solutions are not only created by code and databases, but by the people who will use them. With a personal, present, and trust-inspiring approach, he steps directly into your organization.",
      personText2: "He creates an environment characterized by psychological safety, where teams dare to take ownership, and where transparency and a fixed cadence drive the project forward. It's about moving from fragmented efforts to predictable delivery – with a smile and respect for the individual.",
      customersTag: "Voice of the customers",
      customersTitle: "What do the clients say?",
      customersSubtitle: "Testimonials from companies and partners who have had René on the sidelines in complex processes.",
      experienceTag: "Documented experience",
      experienceTitle: "Selected cases & results",
      experienceCta: "See all experience",
      skillsInPlay: "Skills in play",
      trackRecordTag: "Track record · Cases",
      projectDescTitle: "Project Description & Results",
      ctaTitle: "Shall we create the next successful result together?",
      ctaText: "René is ready to step in as your independent advisor and lead. Let's have a non-binding chat about how we can secure your project."
    },
    about: {
      title: "About René",
      subtitle: "Experienced IT consultant focused on bridging the gap between business and technology.",
      content1: "I have worked with IT projects for over two decades and have a deep passion for making complex systems and people work together. My approach is pragmatic, honest, and always focused on delivering real value to the business.",
      content2: "Throughout my career, I have held roles as project manager, solution architect, and agile coach. This has given me a broad understanding of the challenges that arise in large IT transformations and how best to solve them.",
      contactCta: "Let's have a non-binding chat",
      personTag: "The person behind the product",
      compassTitle: "René's professional and personal compass",
      safetyTitle: "Psychological safety",
      safetyText: "When teams feel safe, they dare to tell the truth about risks and errors. This is the foundation for any successful go-live.",
      cadenceTitle: "Fixed cadence & transparency",
      cadenceText: "Clarity on tasks, ownership, and progress removes stress and creates predictable delivery.",
      bridgeTitle: "Bridging",
      bridgeText: "René speaks the language of the business, the IT department, and the implementation partner, ensuring full alignment.",
      pragmaticTitle: "Pragmatic execution",
      pragmaticText: "Governance is important, but it must always be adapted to the real business environment so that it supports operations.",
      profileTag: "Senior Freelance ERP Specialist, Coach & Business Psychotherapist",
      profileQuote: "\"I believe that complex ERP systems only succeed if the people who will use them are safe, motivated, and aligned.\"",
      therapist: "Business Psychotherapist",
      member: "Member of the Danish Psychotherapist Association",
      linkedinTitle: "Contact René on LinkedIn",
      linkedinText: "René regularly shares experiences, articles, and agile tips on his LinkedIn profile. Reach out for a non-binding chat or follow his professional updates.",
      linkedinConnect: "Connect on LinkedIn",
      visualTag: "Visual documentation",
      visualClick: "Click on an image to view it in full size."
    },
    experience: {
      title: "Experience",
      subtitle: "An overview of selected projects and roles throughout my career.",
      period: "Period",
      skills: "Skills"
    },
    services: {
      erpSubtitle: "Get control of your ERP project with an experienced lead who understands both business and technology.",
      dataSubtitle: "Minimize the risk of system changes with a structured approach to data migration.",
      agileSubtitle: "Create better results and higher well-being with well-functioning agile teams."
    },
    contact: {
      title: "Contact",
      subtitle: "Let's have a dialogue about how I can help with your next IT project.",
      infoTitle: "Contact Information",
      infoDesc: "You are always welcome to call or write for a non-binding chat about your challenges and needs.",
      contactTag: "Contact · Insightly ApS",
      companyInfo: "Company Info"
    },
    errors: {
      forbidden: "Access Denied",
      forbiddenDesc: "You do not have permission to view this page.",
      notFound: "Page Not Found",
      notFoundDesc: "The page you are looking for does not exist or has been moved.",
      backHome: "Back to home"
    }
  },
  de: {
    nav: {
      home: "Startseite",
      about: "Über René",
      services: "Dienstleistungen",
      erp: "ERP Lead",
      data: "Datenmigration",
      agile: "Agile Scrum Coach",
      experience: "Erfahrung",
      contact: "Kontakt"
    },
    header: {
      specialist: "Senior Freelance ERP & Data Migration Specialist",
      linkedinContact: "Kontakt auf LinkedIn",
      linkedinFollow: "Folgen Sie René auf LinkedIn",
      location: "Svendborg, Dänemark",
      closeMenu: "Menü schließen",
      toggleMenu: "Menü umschalten"
    },
    footer: {
      description: "Insightly ApS bietet unabhängige und professionelle IT-Beratung mit Spezialisierung auf ERP, Datenmigration und agile Transformation.",
      contact: "Kontakt",
      cvr: "MwSt:",
      rights: "Alle Rechte vorbehalten.",
      phone: "Telefon",
      email: "E-Mail",
      address: "Adresse",
      addressValue: "Dronningemaen 68, 5700 Svendborg, Dänemark",
      linkedin: "LinkedIn",
      linkedinConnect: "Auf LinkedIn verbinden",
      formDesc: "Füllen Sie das untenstehende Formular aus, und René wird sich so schnell wie möglich bei Ihnen melden.",
      formSuccessNew: "Neue Nachricht senden",
      contactTitle: "Kontakt",
      contactQuote: "Braucht Ihr ERP-Programm Struktur, Dynamik und eine sichere Lieferung? Oder stehen Sie vor einer komplexen Datenmigration, bei der Sie einen erfahrenen Steuermann benötigen?",
      contactText: "Lassen Sie uns einen unverbindlichen Dialog darüber führen, wie ich Ihrer Organisation helfen kann, ihre Ziele sicher zu erreichen. René deckt die kritischsten Rollen in komplexen ERP- und Transformationsprogrammen ab und fungiert als Bindeglied zwischen Geschäft, IT und Implementierungspartnern.",
      socialMedia: "Soziale Medien",
      advisory: "Senior Freelance ERP & Project Advisory"
    },
    contactForm: {
      title: "Nachricht senden",
      name: "Name",
      email: "E-Mail",
      phone: "Telefon",
      message: "Nachricht",
      send: "Nachricht senden",
      sending: "Sendet...",
      success: "Vielen Dank für Ihre Nachricht. Ich werde mich so schnell wie möglich bei Ihnen melden.",
      error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut."
    },
    home: {
      heroTitle: "Unabhängige IT-Beratung & Projektmanagement",
      heroSubtitle: "Mit über 20 Jahren Erfahrung helfe ich Unternehmen, komplexe ERP-Implementierungen, Datenmigrationen und agile Transformationen erfolgreich zu meistern.",
      heroCta1: "Meine Dienstleistungen",
      heroCta2: "Kontaktieren Sie mich",
      heroCta3: "Kontakt auf LinkedIn",
      servicesTitle: "Kernkompetenzen",
      servicesSubtitle: "Ich biete spezialisierte Beratung in drei Hauptbereichen an und kombiniere dabei tiefes technisches Verständnis mit Geschäftssinn.",
      erpTitle: "ERP Lead",
      erpDesc: "Management komplexer ERP-Projekte von der Analyse bis zum erfolgreichen Go-Live.",
      dataTitle: "Datenmigration",
      dataDesc: "Sichere und strukturierte Übertragung geschäftskritischer Daten.",
      agileTitle: "Agile Scrum Coach",
      agileDesc: "Implementierung agiler Methoden, die echten Mehrwert schaffen.",
      readMore: "Weiterlesen",
      testimonialsTitle: "Kundenstimmen",
      testimonialsSubtitle: "Eine Auswahl an Referenzen von früheren Partnern und Kunden.",
      valuePropositionTag: "Wertversprechen",
      valuePropositionQuote: "ERP-Programme mit Struktur und Dynamik geliefert",
      valuePropositionText: "Senior ERP-Führung mit Fokus auf Governance, Datenmigration und Zusammenarbeit zwischen Business, IT und Implementierungspartnern – von der Planung bis zum sicheren Go-Live.",
      experienceDomainTag: "Erfahrung über Domänen hinweg",
      experienceDomainTitle: "Kombination von Governance mit pragmatischer, praktischer Ausführung",
      experienceDomainText: "René arbeitet im Spannungsfeld zwischen dem Unternehmen, der IT-Abteilung und externen Implementierungspartnern. Er entwirft skalierbare Migrations-Frameworks, etabliert Agilität und stellt sicher, dass Ihre Daten zuverlässig sind und Ihre Teams vor dem Go-Live zuversichtlich und abgestimmt sind.",
      deliveryTitle: "Sichere Lieferung",
      deliveryText: "Fokus auf Go-Live-Bereitschaft und operative Stabilität, die in der Realität funktioniert.",
      governanceTitle: "Starke Governance",
      governanceText: "Kombiniert strategische Governance mit pragmatischer, praktischer Ausführung.",
      servicesTag: "Unsere Dienstleistungen",
      servicesTitle2: "Professionelle Dienstleistungen mit menschlicher Einsicht",
      servicesSubtitle2: "René deckt die kritischsten Rollen in komplexen ERP- und Transformationsprogrammen ab.",
      erpServiceDesc: "Fokus auf Struktur, Governance, Entscheidungsfindung, Fortschritt und Koordination zwischen Geschäft, IT und Implementierungspartnern.",
      dataServiceDesc: "Fokus auf Migrations-Frameworks, Stammdaten, Datenqualität, Compliance, Go-Live-Bereitschaft und stabilen Betrieb nach dem Go-Live.",
      pmTitle: "Project Manager",
      pmServiceDesc: "Steuerung von Umfang, Zeit und Ressourcen in komplexen Geschäftsumgebungen. Brückenbau zwischen IT und Geschäft mit Fokus auf Fortschritt.",
      agileServiceDesc: "Fokus auf Transparenz, Kadenz, psychologische Sicherheit, Teamflow und praktische agile Ausführung in komplexen Programmen.",
      seeExperience: "Erfahrung ansehen",
      strategicTag: "Strategische Positionierung",
      strategicTitle: "Organisationen helfen, die Kontrolle über komplexe ERP-Initiativen zurückzugewinnen",
      strategicText: "Durch Transparenz, Kadenz und psychologische Sicherheit bewegen wir Teams von fragmentierten Bemühungen zu vorhersehbarer Lieferung.",
      personTag: "Der Mensch dahinter",
      personTitle: "Lernen Sie René Vilsgaard kennen",
      personCta: "Lesen Sie mehr über René",
      personSubtitle: "Wo komplexe Systeme auf menschliche Wärme treffen",
      personText1: "In Insightly ApS ist René das Produkt selbst. Er ist ausgebildeter <strong class=\"text-navy-900\">Wirtschaftspsychotherapeut</strong> und Mitglied des <a href=\"https://psykoterapeutforeningen.dk\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-petrol hover:underline inline-flex items-center gap-1 font-semibold\">Dänischen Psychotherapeutenverbandes <i class=\"fa-solid fa-arrow-up-right-from-square text-[10px]\"></i></a>. Er glaubt, dass die besten ERP-Lösungen nicht nur durch Code und Datenbanken geschaffen werden, sondern durch die Menschen, die sie nutzen werden. Mit einem persönlichen, präsenten und vertrauenserweckenden Ansatz tritt er direkt in Ihre Organisation ein.",
      personText2: "Er schafft ein Umfeld, das von psychologischer Sicherheit geprägt ist, in dem Teams es wagen, Verantwortung zu übernehmen, und in dem Transparenz und eine feste Kadenz das Projekt vorantreiben. Es geht darum, von fragmentierten Bemühungen zu vorhersehbarer Lieferung überzugehen – mit einem Lächeln und Respekt für den Einzelnen.",
      customersTag: "Stimme der Kunden",
      customersTitle: "Was sagen die Kunden?",
      customersSubtitle: "Erfahrungsberichte von Unternehmen und Partnern, die René in komplexen Prozessen an ihrer Seite hatten.",
      experienceTag: "Dokumentierte Erfahrung",
      experienceTitle: "Ausgewählte Fälle & Ergebnisse",
      experienceCta: "Alle Erfahrungen ansehen",
      skillsInPlay: "Kompetenzen im Einsatz",
      trackRecordTag: "Erfolgsbilanz · Fälle",
      projectDescTitle: "Projektbeschreibung & Ergebnisse",
      ctaTitle: "Sollen wir gemeinsam das nächste erfolgreiche Ergebnis erzielen?",
      ctaText: "René steht bereit, um als Ihr unabhängiger Berater und Lead einzutreten. Lassen Sie uns ein unverbindliches Gespräch darüber führen, wie wir Ihr Projekt sichern können."
    },
    about: {
      title: "Über René",
      subtitle: "Erfahrener IT-Berater mit Fokus auf die Verbindung von Geschäft und Technologie.",
      content1: "Ich arbeite seit über zwei Jahrzehnten an IT-Projekten und habe eine tiefe Leidenschaft dafür, komplexe Systeme und Menschen zusammenzubringen. Mein Ansatz ist pragmatisch, ehrlich und immer darauf ausgerichtet, echten Mehrwert für das Unternehmen zu liefern.",
      content2: "Im Laufe meiner Karriere hatte ich Rollen als Projektmanager, Lösungsarchitekt und Agile Coach. Dies hat mir ein breites Verständnis für die Herausforderungen bei großen IT-Transformationen und wie man sie am besten löst.",
      contactCta: "Lassen Sie uns unverbindlich sprechen",
      personTag: "Der Mensch hinter dem Produkt",
      compassTitle: "Renés beruflicher und persönlicher Kompass",
      safetyTitle: "Psychologische Sicherheit",
      safetyText: "Wenn sich Teams sicher fühlen, wagen sie es, die Wahrheit über Risiken und Fehler zu sagen. Dies ist die Grundlage für jeden erfolgreichen Go-Live.",
      cadenceTitle: "Feste Kadenz & Transparenz",
      cadenceText: "Klarheit über Aufgaben, Eigenverantwortung und Fortschritt beseitigt Stress und schafft vorhersehbare Lieferungen.",
      bridgeTitle: "Brückenbau",
      bridgeText: "René spricht die Sprache des Unternehmens, der IT-Abteilung und des Implementierungspartners und sorgt so für volle Abstimmung.",
      pragmaticTitle: "Pragmatische Ausführung",
      pragmaticText: "Governance ist wichtig, muss aber immer an das reale Geschäftsumfeld angepasst werden, damit sie den Betrieb unterstützt.",
      profileTag: "Senior Freelance ERP-Spezialist, Coach & Wirtschaftspsychotherapeut",
      profileQuote: "\"Ich glaube, dass komplexe ERP-Systeme nur erfolgreich sind, wenn die Menschen, die sie nutzen sollen, sicher, motiviert und abgestimmt sind.\"",
      therapist: "Wirtschaftspsychotherapeut",
      member: "Mitglied des Dänischen Psychotherapeutenverbandes",
      linkedinTitle: "Kontaktieren Sie René auf LinkedIn",
      linkedinText: "René teilt regelmäßig Erfahrungen, Artikel und agile Tipps auf seinem LinkedIn-Profil. Melden Sie sich für ein unverbindliches Gespräch oder folgen Sie seinen beruflichen Updates.",
      linkedinConnect: "Auf LinkedIn verbinden",
      visualTag: "Visuelle Dokumentation",
      visualClick: "Klicken Sie auf ein Bild, um es in voller Größe anzuzeigen."
    },
    experience: {
      title: "Erfahrung",
      subtitle: "Ein Überblick über ausgewählte Projekte und Rollen im Laufe meiner Karriere.",
      period: "Zeitraum",
      skills: "Kompetenzen"
    },
    services: {
      erpSubtitle: "Übernehmen Sie die Kontrolle über Ihr ERP-Projekt mit einem erfahrenen Lead, der sowohl das Geschäft als auch die Technologie versteht.",
      dataSubtitle: "Minimieren Sie das Risiko von Systemwechseln mit einem strukturierten Ansatz zur Datenmigration.",
      agileSubtitle: "Schaffen Sie bessere Ergebnisse und höheres Wohlbefinden mit gut funktionierenden agilen Teams."
    },
    contact: {
      title: "Kontakt",
      subtitle: "Lassen Sie uns darüber sprechen, wie ich bei Ihrem nächsten IT-Projekt helfen kann.",
      infoTitle: "Kontaktinformationen",
      infoDesc: "Sie können mich jederzeit gerne anrufen oder schreiben, um unverbindlich über Ihre Herausforderungen und Bedürfnisse zu sprechen.",
      contactTag: "Kontakt · Insightly ApS",
      companyInfo: "Unternehmensinfo"
    },
    errors: {
      forbidden: "Zugriff verweigert",
      forbiddenDesc: "Sie haben keine Berechtigung, diese Seite anzuzeigen.",
      notFound: "Seite nicht gefunden",
      notFoundDesc: "Die gesuchte Seite existiert nicht oder wurde verschoben.",
      backHome: "Zurück zur Startseite"
    }
  }
};